// ============================================
// LOGIN - Telegram Login Widget
// ============================================

import { loginWithTelegram } from './api.js';
import { saveAuth } from './auth.js';

// Telegram bot username — REPLACE with actual bot username after creating via @BotFather
const TELEGRAM_BOT_USERNAME = 'mishmarot_fetsh_bot';

// Called by Telegram widget after successful auth
(window as any).onTelegramAuth = async function(user: Record<string, unknown>) {
  try {
    const result = await loginWithTelegram(user);
    saveAuth(result.token, result.user.first_name);
    window.location.reload();
  } catch (e) {
    console.error('Login failed:', e);
    const errorEl = document.getElementById('login-error');
    if (errorEl) {
      errorEl.textContent = 'Не удалось войти. Попробуйте ещё раз.';
      errorEl.style.display = 'block';
    }
  }
};

export function initLogin(): void {
  const container = document.querySelector('.container');
  if (!container) return;

  container.innerHTML = `
    <header class="app-header">
      <h1>
        <img src="logo.png" alt="Mishmarot" class="logo-icon" />
        Mishmarot
      </h1>
    </header>
    <div class="login-container">
      <p class="login-text">Войдите через Telegram для доступа к расписанию</p>
      <div id="telegram-login-widget"></div>
      <div id="login-error" class="login-error" style="display: none;"></div>
    </div>
  `;

  // Dynamically load Telegram widget script
  const script = document.createElement('script');
  script.src = 'https://telegram.org/js/telegram-widget.js?22';
  script.setAttribute('data-telegram-login', TELEGRAM_BOT_USERNAME);
  script.setAttribute('data-size', 'large');
  script.setAttribute('data-onauth', 'onTelegramAuth(user)');
  script.setAttribute('data-request-access', 'write');
  script.async = true;

  document.getElementById('telegram-login-widget')?.appendChild(script);
}
